import { FC, useState } from 'react';
import { useGetCurrentLocation } from 'view/pages/profile/hooks/useGetCurrentLocation';
import Autocomplete from 'view/components/Autocomplete';

const JobLocationAutocomplete: FC<any> = ({
  setValue,
  jobLocationValue,
  marginbottom = 0,
  label = 'Job Location',
}) => {
  const [inputValue, setInputValue] = useState('');
  const [page, setPage] = useState(1);

  const { data, isLoading } = useGetCurrentLocation(10, page, inputValue);

  return (
    <Autocomplete
      name="currentLocation"
      label={label}
      value={jobLocationValue}
      onChange={(value: any) => {
        return setValue('jobLocation', value);
      }}
      inputValue={inputValue}
      setInputValue={setInputValue}
      page={page}
      setPage={setPage}
      data={data}
      isLoading={isLoading}
      getOptionLabel={(option: any) => {
        return `${option.name}`; /* , ${option.state.code} */
      }}
      marginbottom={marginbottom}
    />
  );
};

export default JobLocationAutocomplete;
